<template>
  <div
      class="cashierdiary--panel"
      @mouseenter='isEnter=true'
      @mouseleave="isEnter=false"
      :style="{width:isEnter?'148px':'40px'}"
    >
    <div
      class="cashierdiary--panel-items"
      v-for="(i,index) in dataList"
      @mouseenter='handleMouse(i,2)'
      @click='handleOperation(i)'
      @mouseleave="handleMouse(i,1)"
      :key="index"
    >
      <img :src="getImg(i)" alt="" class="cashierdiary--panel-items-img">
      <span
        class="cashierdiary--panel-items-title"
        :style="{color:i.status===1?'#333':i.status===2?'#1DB388':'#999'}"
      >{{i.name}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isEnter:false,  // 是否鼠标移入
        dataList:[
          {
            name:"新增字段",
            status:1,        // 1、正常；2、鼠标移入；3、禁用状态
            iconName:"c-add-field"
          },
          {
            name:"编辑字段",
            status:1,        // 1、正常；2、鼠标移入；3、禁用状态
            iconName:"c-edit-field"
          },
          {
            name:"微信推送",
            status:1,        // 1、正常；2、鼠标移入；3、禁用状态
            iconName:"c-push-wx"
          }
        ]
      }
    },
    methods: {
      // 点击操作
      handleOperation(i) {
        this.$emit('handleClick',i);
      },
      // 鼠标事件
      handleMouse(i,status) {
        if(i.status===3)  return;
        i.status = status;
      },
      // 根据状态获取icon
      getImg(item) {
        let picPath = "/static/icon/" + item.iconName + '.png';
        if(item.status===2) {
          picPath = "/static/icon/" + item.iconName + '-active.png';
        }else if(item.status===3){
          picPath = "/static/icon/" + item.iconName + '-dis.png';
        }
        return picPath;
      }
    }
  }
</script>

<style lang="less" scoped>
  .cashierdiary--panel {
    background-color: #fff;
    border-radius: 5px;
    width: 148px;
    transition: all .2s;
    overflow: hidden;
    &-items {
      display: flex;
      cursor: pointer;
      align-items: center;
      margin: 10px 0px;
      padding: 10px 12px;
      &:hover {
        background-color: #F2F9FA;
      }
      &-img {
        width: 15px;
        height: 15px;
        margin-right: 27px;
      }
      &-title {
        white-space: nowrap;
        color: #333333;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/attr/c-panel.vue